import React, { useCallback, useEffect, useState, useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import AsttButtonDark from "components/ASTTButtonDark/AsttButtonDark";
import classes from "./TraineeDetails.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import moment from "moment-timezone";
import { rosterConfigAction } from "../../../Store/RosterConfig";
import SearchModal from "../SearchModal/SearchModal";
import { useTranslation } from "react-i18next";
import SearchIcon from "@mui/icons-material/Search";
import BackdropComponent from "../../../components/Spinner/Spinner";
import PropTypes from "prop-types";
import IdmModalContainer from "../IdmTickets/IdmTickets";
import {
  saveRosterTrainee,
  getRosterTrainee,
  getWaveByClassRequestId,
  getRosterConfig,
  createIdmOrderRequest,
  getIdmRitmDetail,
  SaveAttachmentRitm,
  insertIdmTicket,
  SaveRitmComment,
  SaveAttachmentRitmForClient,
  SaveAttachmentRitmForCapClient,
  getIdmDetails,
  lockRosterConfig,
} from "../../../services/userServices";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

import IdmInputs from "../CreateIdmInputs/CreateIdmInputs";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ActiveTrainee from "../ActiveTrainee/ActiveTrainee";

//Assigne Trainee Start
import AsttButton from "../../AsttButton/AsttButton";
import AsttButtonLight from "../../ASTTButtonLight/AsttButtonLight";
import SouthIcon from "@mui/icons-material/South";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { getTrainees } from "services/userServices";
import Drawer from "@mui/material/Drawer";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
//Assigne Trainee End

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 900,
  height: 580,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const searchTrainerStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const showAfterTimeout = (func, seconds) => {
  setTimeout(() => {
    func(true);
  }, seconds);
};

const sortAscending = (data, colName) => {
  return data
    .toSorted((a, b) => {
      if (a[colName] > b[colName]) return 1;
      else if (b[colName] > a[colName]) return -1;
      else return 0;
    })
    .slice();
};

const sortDescending = (data, colName) => {
  return data
    .toSorted((a, b) => {
      if (a[colName] < b[colName]) return 1;
      else if (b[colName] < a[colName]) return -1;
      else return 0;
    })
    .slice();
};

const prepareDateTimeObject = (dateValue) => {
  let currentDate = new Date(dateValue);
  let date = moment(new Date(currentDate)).format("YYYY-MM-DD");
  let hours = currentDate.getHours();
  let minutes = currentDate.getMinutes();
  let ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours || 12; // the hour '0' should be '12'
  minutes = minutes < 10 ? "0" + minutes : minutes;
  let strTime = hours + ":" + minutes + " " + ampm;
  return {
    date: date,
    time: strTime,
  };
};
const prepareCreateIDMRequestPayload = (askNowDetail) => ({
  sysparm_quantity: 1,
  variables: {
    cmdb_ci: "dad2e7294ffa1280f15e3285f110c7ff",
    caller_id: askNowDetail.requestFor,
    idm_requested_date:
      askNowDetail.reqForDateTime.date + " " + askNowDetail.reqForDateTime.time,
    idm_access_type: askNowDetail.typeOfRequest,
    idm_multiple_porgram: "yes",
    idm_emp_type: "agent",
    idm_wave_number: askNowDetail.waveNumber,
    idm_request_number: askNowDetail.taleoReqId,
    tci_ttd_start_date: askNowDetail.tCITTDStartDate,
    idm_tte_training_date: askNowDetail.tteTrainingDate,
    product_training_start_date: askNowDetail.productionTrainingStart,
    idm_production_date: askNowDetail.productionDate,
    idm_site: askNowDetail.siteLocation,
    idm_new_cp: askNowDetail.newClientProgram,
    technology_Deployment_Type: askNowDetail.techDeploymentType,
    idm_wave_trainer: askNowDetail.waveTrainer,
    idm_ops_manager: askNowDetail.manager,
    idm_product_training_date: askNowDetail.tteTrainingDate,
    requested_for_time: askNowDetail.timeZone,
    system_account_provisioning_only: askNowDetail.noEquipmentRequired,
    idm_mul_cp2:
      askNowDetail.typeOfRequest === "Change Role"
        ? askNowDetail.currentClientProgram
        : [askNowDetail.newClientProgram],
  },
});

const getAppBarClassName = () => {
  if (window.location.host !== "astt.ttec.com") {
    return "env-devcolor";
  }
  return "env-prodcolor";
};

const SearchTrainerModal = (props) => {
  const { modalOpen, handleSearchTrainerClose, searchType } = props;
  return (
    <Modal
      open={modalOpen}
      onClose={handleSearchTrainerClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={searchTrainerStyle}>
        <SearchModal
          onClose={handleSearchTrainerClose}
          type={searchType}
        ></SearchModal>
      </Box>
    </Modal>
  );
};

SearchTrainerModal.propTypes = {
  modalOpen: PropTypes.bool,
  handleSearchTrainerClose: PropTypes.func,
  searchType: PropTypes.any,
};

const IDMModal = (props) => {
  const { open, handleClose, rosterID } = props;
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IdmModalContainer
          onClose={handleClose}
          classRosterId={rosterID}
        ></IdmModalContainer>
      </Box>
    </Modal>
  );
};

IDMModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  rosterID: PropTypes.string,
};

const IDMGenerateResponseModal = (props) => {
  const {
    generateOpen,
    traineeForShow,
    isTraineeNotSelected,
    taleoReqIdShow,
    isRuleFailTaleoReqId,
    requestedForShow,
    isRuleFailRequestedFor,
    isReqDateTime,
    askNowDetail,
    isReqTimeZone,
    tteDateForShow,
    isRuleFailTteDate,
    siteLocShow,
    isRuleFailSiteLocation,
    ncShow,
    isCurrentClientProgram,
    isNewClientProgram,
    wtShow,
    isRuleFailWaveTrainer,
    managerShow,
    isRuleFailManager,
    createAskNowHeading,
    createAskNowSuccess,
    reqNumber,
    ritmHeading,
    ritmShow,
    ritmNumber,
    uploadRitmHeading,
    showRitmUpload,
    idmTicketError,
    finishedGenrating,
    closeGeneratingAskNowTicket,
  } = props;
  return (
    <Modal
      open={generateOpen}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div>
          <p className={"text-center m-20px fs-1-5"}>
            Generating Ask Now Ticket
          </p>
          <p>--Verifying AskNow SysId Values--</p>

          {traineeForShow && (
            <p className="main-section m-5-0px">
              Trainees:
              {isTraineeNotSelected ? (
                <span className="redColor">
                  No trainee selected from table!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {taleoReqIdShow && (
            <p className="main-section m-5-0px">
              Taleo Req Id:
              {isRuleFailTaleoReqId ? (
                <span className="redColor">
                  Please see Taleo Req, Some error occurred while updating
                  values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {requestedForShow && (
            <p className="main-section m-5-0px">
              Requested For:
              {isRuleFailRequestedFor ? (
                <span className="redColor">
                  Please see Requested For, Some error occurred while updating
                  values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          <p className="main-section m-5-0px">
            Req. For Date/Time :
            {isReqDateTime ? (
              <span className="redColor">
                Please see Req. For Date/Time, Some error occurred while
                updating values!
              </span>
            ) : (
              <span className="blueColor">OK</span>
            )}
          </p>
          {askNowDetail.typeOfRequest === "Change Role" && (
            <p className="main-section m-5-0px">
              Req. For TimeZone :
              {isReqTimeZone ? (
                <span className="redColor">
                  Please see Req. For TimeZone, Some error occurred while
                  updating values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {tteDateForShow && (
            <p className="main-section m-5-0px">
              TTE Date:
              {isRuleFailTteDate ? (
                <span className="redColor">
                  Please see TTE Date, Some error occurred while updating
                  values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {siteLocShow && (
            <p className="main-section m-5-0px">
              Site/Location:
              {isRuleFailSiteLocation ? (
                <span className="redColor">
                  Please see Site/Location, Some error occurred while updating
                  values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {ncShow && (
            <p className="main-section m-5-0px">
              New Client Program:
              {isNewClientProgram ? (
                <span className="redColor">
                  Please see New Client Program, Some error occurred while
                  updating values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {askNowDetail.typeOfRequest === "Change Role" && (
            <p className="main-section m-5-0px">
              Current Client Program:
              {isCurrentClientProgram ? (
                <span className="redColor">
                  Please see Current Client Program, Some error occurred while
                  updating values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {wtShow && (
            <p className="main-section m-5-0px">
              Wave Trainer:
              {isRuleFailWaveTrainer ? (
                <span className="redColor">
                  Please see Wave Trainer, Some error occurred while updating
                  values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {managerShow && (
            <p className="main-section m-5-0px">
              Manager:
              {isRuleFailManager ? (
                <span className="redColor">
                  Please see Manager, Some error occurred while updating values!
                </span>
              ) : (
                <span className="blueColor">OK</span>
              )}
            </p>
          )}

          {createAskNowHeading && (
            <p className="m-15-0 font-bolder ">--Creating AskNow Ticket--</p>
          )}
          {createAskNowSuccess && (
            <p className="m-5-0px">{reqNumber} Successfully Created!</p>
          )}
          {ritmHeading && (
            <p className="m-15-0 font-bolder ">
              --Getting RITM Ticket Number--
            </p>
          )}
          {ritmShow && <p className="m-5-0px">{ritmNumber} Found!</p>}

          {uploadRitmHeading && (
            <p className="m-15-0 font-bolder ">
              --Uploading Onboarding Template to RITM ticket--
            </p>
          )}
          {showRitmUpload && (
            <p className="m-5-0px">
              OBT Successfully Uploaded to {ritmNumber} !
            </p>
          )}

          {idmTicketError && (
            <p className="main-section m-5-0px">
              <span className="redColor">
                Unable to create ticket. Please wait for some time before you
                retry. If this issue reoccurs, please report this issue and
                include the error shown below.
              </span>
            </p>
          )}
          {finishedGenrating && (
            <div className="text-center m-20px">
              <AsttButtonDark onClick={closeGeneratingAskNowTicket}>
                Close
              </AsttButtonDark>
            </div>
          )}
        </div>
      </Box>
    </Modal>
  );
};

IDMGenerateResponseModal.propTypes = {
  generateOpen: PropTypes.bool,
  traineeForShow: PropTypes.bool,
  isTraineeNotSelected: PropTypes.bool,
  taleoReqIdShow: PropTypes.bool,
  isRuleFailTaleoReqId: PropTypes.bool,
  requestedForShow: PropTypes.bool,
  isRuleFailRequestedFor: PropTypes.bool,
  isReqDateTime: PropTypes.bool,
  askNowDetail: PropTypes.object,
  isReqTimeZone: PropTypes.bool,
  tteDateForShow: PropTypes.bool,
  isRuleFailTteDate: PropTypes.bool,
  siteLocShow: PropTypes.bool,
  isRuleFailSiteLocation: PropTypes.bool,
  ncShow: PropTypes.bool,
  isCurrentClientProgram: PropTypes.bool,
  isNewClientProgram: PropTypes.bool,
  wtShow: PropTypes.bool,
  isRuleFailWaveTrainer: PropTypes.bool,
  managerShow: PropTypes.bool,
  isRuleFailManager: PropTypes.bool,
  createAskNowHeading: PropTypes.bool,
  createAskNowSuccess: PropTypes.bool,
  reqNumber: PropTypes.string,
  ritmHeading: PropTypes.bool,
  ritmShow: PropTypes.bool,
  ritmNumber: PropTypes.string,
  uploadRitmHeading: PropTypes.bool,
  showRitmUpload: PropTypes.bool,
  idmTicketError: PropTypes.bool,
  finishedGenrating: PropTypes.bool,
  closeGeneratingAskNowTicket: PropTypes.func,
};

const isRosterIdNull = (rosterId) => rosterId === "null" || rosterId === null;
const TraineeDetails = (props) => {
  //will remove IDMTicketDisplay hook in future once IDM ticket creation get available for everyone. For QA only.
  // const [IDMTicketDisplay, setIDMTicketDisplay] = useState(false); --ASTT-2156
  const [idmTicketCreate, setIdmTicketCreate] = useState(false);
  const [idmTicketError, setIdmTicketError] = useState(false);
  const { t } = useTranslation(["rosterConfig"]);
  const [idmTickets, setIdmTickets] = useState("");
  const [openCreateIdm, setOpenCreateIdm] = React.useState(false);
  const [assignedTraineeData, setAssignedTraineeData] = useState([]);
  const [selectedTrainerDropDownValue, setSelectedTrainerDropDownValue] =
    useState("");
  const [isCurrentClientProgram, setIsCurrentClientProgram] = useState(false);
  const [countAllTraineeStatus, setCountAllTraineeStatus] = useState(0);
  const [assignTraineeUpdate, setAssignTraineeUpdate] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [sortOrder, setSortOrder] = useState(false);
  const [sortOrderTrainee, setSortOrderTrainee] = useState(false);
  const [requisitionValue, setRequisitionValue] = useState(
    localStorage.getItem("requisitionId")?.split(",")[0],
  );
  const createNewRosterWithoutClone = isRosterIdNull(props.rosterID);
  const [loading, setLoading] = useState([false]);
  const askNowDetail = useSelector((state) => state.askNow);
  const [isRuleFailTaleoReqId, setIsRuleFailTaleoReqId] = useState(false);
  const [taleoReqIdShow, setTaleoReqIdShow] = useState(false);
  const [isTraineeNotSelected, setIsTraineeNotSelected] = useState(false);
  const [isRuleFailRequestedFor, setIsRuleFailRequestedFor] = useState(false);
  const [isReqDateTime, setIsReqDateTime] = useState(false);
  const [isReqTimeZone, setIsReqTimeZone] = useState(false);
  const [isRuleFailSiteLocation, setIsRuleFailSiteLocation] = useState(false);
  const [isNewClientProgram, setIsNewClientProgram] = useState(false);
  const [isRuleFailWaveTrainer, setIsRuleFailWaveTrainer] = useState(false);
  const [isRuleFailManager, setIsRuleFailManager] = useState(false);
  const [isRuleFailTteDate, setIsRuleFailTteDate] = useState(false);
  const [resetActiveTrainee, setResetActiveTrainee] = useState(false);
  const [traineeForShow, setTraineeForShow] = useState(false);
  const [tteDateForShow, setTteDateForShow] = useState(false);
  const [requestedForShow, setRequestedForShow] = useState(false);
  const [siteLocShow, setSiteLocShow] = useState(false);
  const [ncShow, setNcShow] = useState(false);
  const [wtShow, setWtShow] = useState(false);
  const [managerShow, setManagerShow] = useState(false);
  const [finishedGenrating, setFinishedGenrating] = useState(false);
  const [searchType, setSearchType] = useState("");
  const [createAskNowHeading, setCreateAskNowHeading] = useState(false);
  const [createAskNowSuccess, setCreateAskNowSuccess] = useState(false);
  const [reqNumber, setReqNumber] = useState("");
  const [ritmHeading, setRitmHeading] = useState(false);
  const [ritmShow, setRitmShow] = useState(false);
  const [ritmNumber, setRitmNumber] = useState("");
  const [uploadRitmHeading, setUploadRitmHeading] = useState(false);
  const [showRitmUpload, setShowRitmUpload] = useState(false);
  const [noRecords, setNoRecords] = useState(false);
  const requisitionRef = useRef();
  const oracleRef = useRef();
  const [drawerType, setDrawerType] = useState("add");
  const [traineeData, setTraineeData] = useState([]);
  const [traineeFilteredData, setTraineeFilteredData] = useState([]);
  const [checkedData, setCheckedData] = useState([]);
  const [oracleStatus, setOracleStatus] = useState([]);
  const navigate = useNavigate();
  const [state, setState] = React.useState({
    right: false,
  });
  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoading(true);
      }

      try {
        // ASTT-2274 - Avoiding API call when ClassRosterID is null [Create new roster without clone roster scenario]
        const getRosterTrainees = createNewRosterWithoutClone
          ? { data: null }
          : await getRosterTrainee(props.rosterID);

        if (cancelled) return;

        if (getRosterTrainees.data === null) {
          if (!cancelled) {
            setAssignedTraineeData([]);
          }
        } else {
          if (!cancelled) {
            setAssignedTraineeData(getRosterTrainees.data);
          }
        }

        if (props.type !== "edit") {
          const waveDetails = await getWaveByClassRequestId(
            props.classRequestId,
          );

          if (cancelled) return;

          if (waveDetails.status === true) {
            if (!cancelled) {
              dispatch(rosterConfigAction.wave(waveDetails.data));
            }
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch data:", error);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [assignTraineeUpdate]);

  const getIdmTicketDetailsByRoster = async () => {
    //ASTT-2274 - Avoiding API call when ClassRosterID is null [Create new roster with out clone roster scenario]
    const idmDetails = createNewRosterWithoutClone
      ? { status: false }
      : await getIdmDetails(props.rosterID);
    if (idmDetails.status === true) {
      let tickets = idmDetails.data
        .map(function (item) {
          return item["idmTicketNumber"];
        })
        .join();
      setIdmTickets(tickets);
      dispatch(rosterConfigAction.rosterIdm(tickets));
    } else {
      setIdmTickets("");
      dispatch(rosterConfigAction.rosterIdm(""));
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let cancelled = false;

    const initialize = async () => {
      try {
        await getIdmTicketDetailsByRoster();

        if (cancelled) return;

        if (
          rosterConfig.productTrainingDate.date != null &&
          rosterConfig.productionStartDate != null &&
          (rosterConfig.tciDate.date != null ||
            rosterConfig.ttdBotDate.date != null)
        ) {
          if (!cancelled) {
            setIdmTicketCreate(true);
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to get IDM ticket details:", error);
        }
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, []);

  const handleClickOpen = () => {
    setOpenCreateIdm(true);
    setResetActiveTrainee(false);
  };

  const hanldeIdmClose = async () => {
    await getIdmTicketDetailsByRoster();
    setOpenCreateIdm(false);
    setResetActiveTrainee(true);
  };

  const rosterConfig = useSelector((state) => state.rosterConfig);
  const dispatch = useDispatch();

  const [open, setOpen] = React.useState(false);
  const [generateOpen, setGenerateOpen] = React.useState(false);

  const handleClose = async () => {
    await getIdmTicketDetailsByRoster();
    setOpen(false);
  };

  const handleSrwDateChange = (event) => {
    const obj = prepareDateTimeObject(event.target.value);
    dispatch(rosterConfigAction.srw(obj));
  };

  const [modalOpen, setModalOpen] = React.useState(false);

  const handleOpenSearchTrainer = useCallback((type) => {
    setSearchType(type);
    setModalOpen(true);
  }, []);

  const handleSearchTrainerClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  const createIdmTicketRequest = prepareCreateIDMRequestPayload(askNowDetail);

  const prepareActiveTrainees = (data) => {
    const isChangeRoleRequest = askNowDetail.typeOfRequest === "Change Role";
    return data.activeTrainee.map((item) => {
      return {
        oracleId: item.oracleId,
        firstName: item.firstName,
        lastName: item.lastName,
        cppClientCode: isChangeRoleRequest
          ? askNowDetail.newClientCode
          : item.cppClientCode,
        cppProgramCode: isChangeRoleRequest
          ? askNowDetail.newProgramCode
          : item.cppProgramCode,
        cppProjectCode: isChangeRoleRequest
          ? askNowDetail.newProjectCode
          : item.cppProjectCode,
        jobTitle: item.jobTitle,
        department: item.department,
        locationId: item.locationId,
        tdt: askNowDetail.techDeploymentType,
      };
    });
  };

  const saveAttachment = async (payload) => {
    const response = await SaveAttachmentRitm(payload);

    if (
      askNowDetail.clientName.toLowerCase().includes("century") ||
      askNowDetail.clientName.toLowerCase().includes("kaiser") ||
      askNowDetail.clientName.toLowerCase().includes("booking")
    ) {
      let clientTrainees = askNowDetail.activeTrainee.map((item) => {
        return {
          oracleId: item.oracleId,
          firstName: item.firstName,
          lastName: item.lastName,
          requestType: askNowDetail.typeOfRequest,
        };
      });
      let AttachForClientPayload = {
        Table_sys_id: payload?.SysId,
        Trainees: clientTrainees,
      };

      const clientResponse = await SaveAttachmentRitmForClient(
        AttachForClientPayload,
      );

      if (response.status === true && clientResponse.status === true) {
        setTimeout(() => {
          setShowRitmUpload(true);
          setUploadRitmHeading(true);
        }, 7000);
      }
    }

    if (askNowDetail.clientName.toLowerCase().includes("capital one")) {
      let clientTrainees = askNowDetail.activeTrainee.map((item) => {
        return {
          oracleId: item.oracleId,
          firstName: item.firstName,
          middleName: "",
          lastName: item.lastName,
        };
      });
      let AttachForClientPayload = {
        Table_sys_id: payload?.SysId,
        Trainees: clientTrainees,
      };

      const clientResponse = await SaveAttachmentRitmForCapClient(
        AttachForClientPayload,
      );

      if (response.status === true && clientResponse.status === true) {
        setTimeout(() => {
          setShowRitmUpload(true);
          setUploadRitmHeading(true);
        }, 7000);
      }
    }
  };

  const insertTicket = async (idmTicketNumber) => {
    let trainees = askNowDetail.activeTrainee.map((item) => {
      return {
        classTraineeId: item.classTraineeId,
      };
    });

    let payload = {
      classRosterId: props.rosterID,
      idmTicketNumber: idmTicketNumber,
      createdBy: localStorage.getItem("User"),
      classTrainees: trainees,
    };

    await insertIdmTicket(idmTicketNumber, payload, props.rosterID, false);
  };

  const insertComment = async (RITMRequest) => {
    let reportPII = `${window.location.origin}/contact-roster/${props.rosterID}' target="_blank"`;
    let ritmSysId = RITMRequest.data["result"].sysid;
    let reportName = `${window.location.origin}/OBT/${RITMRequest.data["result"].number}' target="_blank"`;
    let workNote = `[code]<a href='${reportName}>${window.location.origin}/OBT/${RITMRequest.data["result"].number}
          </a> </br> </br>  <a href='${reportPII}>${window.location.origin}/contact-roster/${props.rosterID}</a>[/code]`;

    let payloadComment = {
      work_Notes: workNote,
    };

    await SaveRitmComment(ritmSysId, payloadComment);
  };

  const RITMPostCreationProcess = async (requestSysId) => {
    const getRitmRequest = await getIdmRitmDetail(requestSysId);
    if (getRitmRequest.status === true) {
      setRitmNumber(getRitmRequest.data["result"].number);

      showAfterTimeout(setRitmHeading, 8000);

      setTimeout(() => {
        setRitmShow(true);
        setUploadRitmHeading(true);
      }, 9000);

      let SysId = getRitmRequest.data["result"].sysid;

      let selectedTrainees = prepareActiveTrainees(askNowDetail);

      let traineesPayload = {
        Table_sys_id: SysId,
        Trainees: selectedTrainees,
      };

      await saveAttachment(traineesPayload);

      await insertTicket(getRitmRequest.data["result"].number);

      await insertComment(getRitmRequest);

      setResetActiveTrainee(false);
    }
  };

  const createTicket = async () => {
    showAfterTimeout(setCreateAskNowHeading, 4000);
    const createOrderRequest = await createIdmOrderRequest(
      createIdmTicketRequest,
    );
    if (createOrderRequest.status === true) {
      showAfterTimeout(setCreateAskNowSuccess, 6000);
      const objReqDetails = JSON.parse(createOrderRequest["data"]);
      setReqNumber(objReqDetails["result"].number);
      const reqSysId = objReqDetails["result"].sys_id;
      await RITMPostCreationProcess(reqSysId);
    } else {
      showAfterTimeout(setIdmTicketError, 9000);
    }
  };

  const CreateIdmTicket = async () => {
    setGenerateOpen(true);
    let isValidationFail = false;
    showAfterTimeout(setTraineeForShow, 1000);
    showAfterTimeout(setRequestedForShow, 1000);
    showAfterTimeout(setTaleoReqIdShow, 1000);

    if (askNowDetail.reqForDateTime === "") {
      isValidationFail = true;
      showAfterTimeout(setIsReqDateTime, 1000);
    }
    if (
      askNowDetail.typeOfRequest === "Change Role" &&
      askNowDetail.timeZone === ""
    ) {
      isValidationFail = true;
      showAfterTimeout(setIsReqTimeZone, 1000);
    }
    if (
      askNowDetail.typeOfRequest === "Change Role" &&
      askNowDetail.currentClientProgram === ""
    ) {
      setIsCurrentClientProgram(true);
      isValidationFail = true;
    }
    showAfterTimeout(setTteDateForShow, 1000);

    if (!askNowDetail.requestFor.length) {
      setIsRuleFailRequestedFor(true);
      isValidationFail = true;
    }

    if (askNowDetail.taleoReqId.length !== 5) {
      setIsRuleFailTaleoReqId(true);
      isValidationFail = true;
    }

    if (!askNowDetail.activeTrainee.length) {
      isValidationFail = true;
      setIsTraineeNotSelected(true);
    }
    if (!askNowDetail.tteTrainingDate.length) {
      setIsRuleFailTteDate(true);
      isValidationFail = true;
    }
    showAfterTimeout(setSiteLocShow, 1500);

    if (!askNowDetail.siteLocation.length) {
      setIsRuleFailSiteLocation(true);
      isValidationFail = true;
    }
    showAfterTimeout(setNcShow, 2000);

    if (!askNowDetail.newClientProgram.length) {
      setIsNewClientProgram(true);
      isValidationFail = true;
    }
    showAfterTimeout(setWtShow, 2500);

    if (!askNowDetail.waveTrainer.length) {
      setIsRuleFailWaveTrainer(true);
      isValidationFail = true;
    }
    showAfterTimeout(setManagerShow, 3000);

    if (!askNowDetail.manager.length) {
      setIsRuleFailManager(true);
      isValidationFail = true;
    }

    if (!isValidationFail) {
      await createTicket();
    }
    showAfterTimeout(setFinishedGenrating, 9500);
  };

  const closeGeneratingAskNowTicket = () => {
    if (ritmHeading === true) {
      setResetActiveTrainee(true);
    }
    setTaleoReqIdShow(false);
    setIsRuleFailTaleoReqId(false);
    setIsTraineeNotSelected(false);
    setIsRuleFailTteDate(false);
    setRequestedForShow(false);
    setIsRuleFailRequestedFor(false);
    setIsCurrentClientProgram(false);
    setIsReqDateTime(false);
    setIsReqTimeZone(false);
    setSiteLocShow(false);
    setIsRuleFailSiteLocation(false);
    setNcShow(false);
    setIsNewClientProgram(false);
    setWtShow(false);
    setIsRuleFailWaveTrainer(false);
    setManagerShow(false);
    setIsRuleFailManager(false);
    setCreateAskNowHeading(false);
    setCreateAskNowSuccess(false);
    setRitmHeading(false);
    setRitmShow(false);
    setUploadRitmHeading(false);
    setShowRitmUpload(false);
    setFinishedGenrating(false);
    setGenerateOpen(false);
    setIdmTicketError(false);
  };

  const toggleDrawer = (anchor, open, type) => async (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    type = type || drawerType;
    setDrawerType(type);
    setTraineeFilteredData([]);
    setState({ ...state, [anchor]: open });
    setNoRecords(false);
    setAssignTraineeUpdate(false);
    setSelectedTrainerDropDownValue("");
    setCountAllTraineeStatus(0);
    setTraineeFilteredData([]);
    setCheckedData([]);
    if (localStorage.getItem("requisitionId")?.split(",").length === 1) {
      setRequisitionValue(localStorage.getItem("requisitionId")?.split(",")[0]);
    } else {
      setRequisitionValue("");
    }
    await requisitionIdAutoPopulate();
  };

  const setUpOracleStatus = (data) => {
    let dropDownData = data.reduce((acc, item) => {
      acc[item.TraineeStatus] = (acc[item.TraineeStatus] || 0) + 1;
      return acc;
    }, {});
    setOracleStatus(dropDownData);
    let countAllTraineeStatus = Object.entries(dropDownData).reduce(
      (acc, item) => {
        acc += (acc[item] || 0) + item[1];
        return acc;
      },
      0,
    );
    setCountAllTraineeStatus(countAllTraineeStatus);
  };

  const resetTraineesData = () => {
    setTraineeData([]);
    setTraineeFilteredData([]);
    setNoRecords(true);
    setSelectedTrainerDropDownValue("");
    setCountAllTraineeStatus(0);
  };

  const fetchTrainees = async (requistionId, oracleIds) => {
    const { rosterID, classRequestId } = props;
    let trainees = await getTrainees(
      requistionId,
      oracleIds,
      rosterID,
      classRequestId,
    );
    setCheckedData([]);
    if (!trainees.data) {
      resetTraineesData();
    } else {
      setTraineeData(trainees.data);
      if (oracleIds.length === 0) {
        const hiredLength = trainees.data.filter((ele) => ele === "Hired");
        if (hiredLength.length) {
          setSelectedTrainerDropDownValue("Hired");
          setTraineeFilteredData(
            trainees.data.filter((item) => item.TraineeStatus === "Hired"),
          );
        } else {
          setSelectedTrainerDropDownValue(trainees.data[0].TraineeStatus);
          setTraineeFilteredData(
            trainees.data.filter(
              (item) => item.TraineeStatus === trainees.data[0].TraineeStatus,
            ),
          );
        }
      } else {
        setSelectedTrainerDropDownValue("");
        setTraineeFilteredData(trainees.data);
      }
      setNoRecords(false);
      setUpOracleStatus(trainees.data);
    }
  };

  const requisitionIdAutoPopulate = async () => {
    const requistionId = localStorage.getItem("requisitionId")?.split(",");
    if (requistionId.length === 1 && requistionId[0] !== "") {
      await fetchTrainees(requistionId, []);
    }
  };

  const onSubmit = async () => {
    const oracleIds =
      oracleRef.current.value === "" ? [] : oracleRef.current.value;
    try {
      await fetchTrainees(requisitionRef.current.value, oracleIds);
    } catch (error) {
      resetTraineesData();
    }
  };

  const handleAllChecked = (event) => {
    let data = traineeFilteredData.map((trainee) => {
      trainee.isChecked = event.target.checked;
      return trainee;
    });

    setTraineeFilteredData(data);
    if (event.target.checked) {
      setCheckedData(data.map((item) => item.isChecked));
    } else {
      setCheckedData([]);
    }
    event.target.checked ? setCheckAll(true) : setCheckAll(false);
  };

  const clearCheck = () => {
    setCheckedData(0);
  };

  const onChangeTraineeChecked = (event, OracleId, i) => {
    let allChecked;
    if (OracleId) {
      allChecked = traineeFilteredData.map((item) => {
        if (item.OracleId === OracleId) {
          return { ...item, isChecked: event.target.checked };
        } else {
          return item;
        }
      });
    } else {
      allChecked = traineeFilteredData.map((item, index) => {
        if (i === index) {
          return { ...item, isChecked: event.target.checked };
        } else {
          return item;
        }
      });
    }

    setTraineeFilteredData(allChecked);
    setCheckedData(
      allChecked.map((item) => item.isChecked === true).filter(Boolean),
    );
    if (!event.target.checked) {
      setCheckAll(false);
    }
    if (event.target.checked) {
      if (
        traineeFilteredData.length ===
        allChecked.map((item) => item.isChecked === true).filter(Boolean).length
      ) {
        setCheckAll(false);
      }
    }
  };

  const saveTrainee = async () => {
    let selectedData = traineeFilteredData.filter((item) => {
      return item.isChecked;
    });

    if (assignedTraineeData.length) {
      setAssignedTraineeData(assignedTraineeData.concat(selectedData));
    }

    let trainees = selectedData.map((item) => {
      return {
        candidateId: item.CandidateId,
        employeeStatus: item.EmployeeStatus,
        firstName: item.FirstName,
        lastName: item.LastName,
        message_MultipleActiveRosters: "",
        oracleId: item.OracleId,
        traineeStatus: item.TraineeStatus,
      };
    });
    let payload = {
      classRosterId: props.rosterID,
      requisitionId: requisitionRef.current.value,
      modifiedby: localStorage.getItem("User"),
      trainees: trainees,
    };
    await saveRosterTrainee(payload);
    setAssignTraineeUpdate(!assignTraineeUpdate);
  };

  const onTraineeSave = async () => {
    await saveTrainee();
    setDrawerType("add");
    setState({ ...state, right: false });
  };

  const handleChange = (e) => {
    setTraineeFilteredData(
      traineeData.filter((item) => item.TraineeStatus === e.target.value),
    );
  };

  const onClear = () => {
    requisitionRef.current.value = "";
    setTraineeFilteredData([]);
    setSelectedTrainerDropDownValue("");
    setCheckAll(false);
    setCheckedData([]);
    setNoRecords(false);
    setAssignTraineeUpdate(false);
    setSelectedTrainerDropDownValue("");
    setCountAllTraineeStatus(0);
    oracleRef.current.value = "";
    setRequisitionValue("");
    setTraineeFilteredData([]);
  };

  const onTraineeSaveAndReq = async () => {
    if (traineeFilteredData.length) {
      await saveTrainee();
      setAssignTraineeUpdate(false);
      setSelectedTrainerDropDownValue("");
    }
    setCountAllTraineeStatus(0);
    requisitionRef.current.value = "";
    oracleRef.current.value = "";
    setTraineeFilteredData([]);
    setCheckedData([]);
  };

  const onCancel = () => {
    setTraineeFilteredData([]);
    setDrawerType("add");
    setState({ ...state, right: false });
  };

  const sortingRosterTrainee = (val) => {
    setSortOrder(!sortOrder);
    let filteredTraineeData = [];
    if (sortOrder) {
      filteredTraineeData = sortAscending(assignedTraineeData, val);
    } else {
      filteredTraineeData = sortDescending(assignedTraineeData, val);
    }
    setAssignedTraineeData(filteredTraineeData);
  };

  const sortingTrainees = (val) => {
    setSortOrderTrainee(!sortOrderTrainee);
    let filteredTraineeData = [];
    if (sortOrderTrainee) {
      filteredTraineeData = sortAscending(traineeFilteredData, val);
    } else {
      filteredTraineeData = sortDescending(traineeFilteredData, val);
    }
    setTraineeFilteredData(filteredTraineeData);
  };

  const headerStyle = {
    fontSize: "10px",
    color: "#ED6417",
  };

  const disableTraineeButton = async () => {
    setLoading(true);
    await lockRosterConfig({
      classRosterId: props.rosterID,
      isLocked: rosterConfig.updateAssignRosterLockDate ? 0 : 1,
      modifiedBy: localStorage.getItem("User"),
    });

    const configRosterDetails = await getRosterConfig(props.rosterID);
    dispatch(
      rosterConfigAction.updateAssignRosterLockDate(
        configRosterDetails.data[0].assignTraineesLockTimestamp,
      ),
    );
    setLoading(false);
  };

  const multipleTraineeRedirection = (oracleId) => {
    window.open(`/searchResult/OracleId/${oracleId}`, "_self");
  };

  const requisitionValueChanged = (e) => {
    setRequisitionValue(e.target.value);
  };
  // Assign and get Trainee end

  const handleAssignTrainees = () => {
    navigate(`/assignTrainees/`, {
      state: {
        classRequestId: props.classRequestId,
        classRosterId: props?.rosterID,
      },
    });
  };

  const idmResponseModalProps = {
    generateOpen,
    traineeForShow,
    isTraineeNotSelected,
    taleoReqIdShow,
    isRuleFailTaleoReqId,
    requestedForShow,
    isRuleFailRequestedFor,
    isReqDateTime,
    askNowDetail,
    isReqTimeZone,
    tteDateForShow,
    isRuleFailTteDate,
    siteLocShow,
    isRuleFailSiteLocation,
    ncShow,
    isCurrentClientProgram,
    isNewClientProgram,
    wtShow,
    isRuleFailWaveTrainer,
    managerShow,
    isRuleFailManager,
    createAskNowHeading,
    createAskNowSuccess,
    reqNumber,
    ritmHeading,
    ritmShow,
    ritmNumber,
    uploadRitmHeading,
    showRitmUpload,
    idmTicketError,
    finishedGenrating,
    closeGeneratingAskNowTicket,
  };

  const showRosterLockDateWarning = () =>
    props.type === "edit" && !rosterConfig.rosterLockDate;

  const getAssignTraineeLockedText = (updateAssignRosterLockDate) => {
    if (updateAssignRosterLockDate) {
      return `Assign Trainees locked: ${moment
        .utc(rosterConfig.updateAssignRosterLockDate)
        .tz("America/New_York")
        .format("YYYY-MM-DD hh:mm a")}`;
    }
    return null;
  };

  const getSelectedTraineesText = (selectedTrainerDropDownValue) => {
    if (selectedTrainerDropDownValue) {
      return (
        <Typography
          variant="h2"
          sx={{
            marginLeft: "30px",
            marginTop: "30px",
          }}
        >
          {oracleStatus[selectedTrainerDropDownValue]}/{countAllTraineeStatus}{" "}
          ITEMS - {checkedData.length || "0"} Selected
        </Typography>
      );
    }
    return (
      <Typography
        variant="h2"
        sx={{
          marginLeft: "30px",
          marginTop: "30px",
        }}
      >
        {countAllTraineeStatus}/{countAllTraineeStatus} ITEMS -{" "}
        {checkedData.length || "0"} Selected
      </Typography>
    );
  };

  const handleLockRoster = (updateAssignRosterLockDate) => {
    if (updateAssignRosterLockDate) {
      return (
        <LockOutlinedIcon
          className="cursor-pointer"
          sx={{ fontSize: 45, color: "#07b40c" }}
          onClick={() => disableTraineeButton()}
        >
          {" "}
        </LockOutlinedIcon>
      );
    }
    return (
      <LockOpenOutlinedIcon
        className="cursor-pointer"
        sx={{ fontSize: 45, color: "#ec6517" }}
        onClick={() => disableTraineeButton()}
      >
        {" "}
      </LockOpenOutlinedIcon>
    );
  };

  return (
    <div>
      {loading ? <BackdropComponent /> : null}

      <SearchTrainerModal
        modalOpen={modalOpen}
        handleSearchTrainerClose={handleSearchTrainerClose}
        searchType={searchType}
      ></SearchTrainerModal>

      <Dialog
        PaperProps={{
          sx: {
            backgroundColor: "#f0f0f0",
          },
        }}
        fullScreen
        open={openCreateIdm}
        onClose={hanldeIdmClose}
        TransitionComponent={Transition}
      >
        <AppBar className={getAppBarClassName()} sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              // color="inherit"
              color="black"
              onClick={hanldeIdmClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography
              sx={{ ml: 2, flex: 1 }}
              color="black"
              variant="h5"
              component="div"
            >
              {t("Create AskNow IDM Request")}
            </Typography>
          </Toolbar>
        </AppBar>
        <Grid container>
          <Grid item xs={4}>
            <IdmInputs
              rosterId={props.rosterID}
              classRequestId={props.classRequestId}
              techEquip={rosterConfig.askNowTDT}
            />
          </Grid>
          <Grid item xs={8} className={"m-5-0px"}>
            <ActiveTrainee
              rosterId={props.rosterID}
              resetActiveTrainee={resetActiveTrainee}
            />
          </Grid>
        </Grid>
        <Grid container sx={{ padding: "20px", paddingLeft: "600px" }}>
          <Grid item xs={5} className={"m-5-0px"}>
            <div>
              <AsttButtonDark onClick={CreateIdmTicket}>
                {t("GENERATE IDM TICKET")}
              </AsttButtonDark>
            </div>
          </Grid>
        </Grid>
      </Dialog>
      <Grid container>
        {showRosterLockDateWarning() && (
          <p className="italic-text">
            ** WARNING: Trainees cannot be assigned to roster until Roster Lock
            Date is provided in the parent Class Request **
          </p>
        )}
        {props.type === "edit" && (
          <Grid container>
            <Grid className={"buttonContainer m-5-0px"} item xs={2}>
              {t("modified")}
            </Grid>
            <Grid item xs={6} className={"m-5-0px logo-section"}>
              {rosterConfig.modifiedBy} (
              {moment
                .utc(rosterConfig.modifiedDate)
                .tz("America/New_York")
                .format("YYYY-MM-DD hh:mm:ss A")}
              )
            </Grid>

            <Grid item xs={1} className={"m-5-0px padding-r-20  text-center"}>
              {handleLockRoster(rosterConfig.updateAssignRosterLockDate)}
            </Grid>

            <Grid
              item
              xs={3}
              className={"m-5-0px padding-r-20  logo-section text-center"}
            >
              {rosterConfig.rosterLockDate &&
              !rosterConfig.updateAssignRosterLockDate ? (
                <AsttButtonDark onClick={handleAssignTrainees}>
                  {t("assignTrainees")}
                </AsttButtonDark>
              ) : (
                <AsttButtonLight> ASSIGN TRAINEES </AsttButtonLight>
              )}
            </Grid>
          </Grid>
        )}

        {props.type === "edit" && (
          <Grid container>
            <Grid className={"buttonContainer m-5-0px"} item xs={6}>
              {t("classRosterId")}:
            </Grid>
            <Grid item xs={1} className={"m-5-0px"}>
              {props.rosterID}
            </Grid>
            <Grid item xs={4} className={"m-5-0px"}>
              <i className="italic-text">
                {getAssignTraineeLockedText(
                  rosterConfig.updateAssignRosterLockDate,
                )}
              </i>
            </Grid>
            <Grid item xs={1} className={"m-5-0px"}></Grid>
          </Grid>
        )}

        {props.type === "edit" && (
          <Grid container>
            {" "}
            <Grid className={"buttonContainer m-5-0px"} item xs={6}>
              {t("wave")}:
            </Grid>
            <Grid item xs={5} className={"m-5-0px"}>
              <input
                name="wave"
                className={"dropdown-css p-rl-10"}
                placeholder="Max 300 characters allowed"
                maxLength={300}
                type="text"
                value={rosterConfig.wave}
                onChange={(e) => {
                  let regEx = /^\d*\.?\d*$/;
                  regEx.test(e.target.value) &&
                    dispatch(rosterConfigAction.wave(e.target.value));
                }}
              />
            </Grid>
            <Grid item xs={1} className={"m-5-0px"}></Grid>
          </Grid>
        )}

        <Grid className={"buttonContainer m-5-0px"} item xs={6}>
          {t("productZoomLink")} :
        </Grid>
        <Grid item xs={5} className={"m-5-0px"}>
          <input
            name="product training link"
            className={"dropdown-css p-rl-10  border-blue"}
            placeholder="Max 300 characters allowed"
            maxLength={300}
            type="text"
            value={rosterConfig.productionTrainingZoomLink}
            onChange={(e) =>
              dispatch(
                rosterConfigAction.productionTrainingZoomLink(e.target.value),
              )
            }
          />
        </Grid>
        <Grid item xs={1} className={"m-5-0px"}></Grid>
        <Grid className={"buttonContainer m-5-0px"} item xs={6}>
          {t("productZoomPassword")} :
        </Grid>
        <Grid item xs={5} className={"m-5-0px"}>
          <input
            name="wave"
            className={"dropdown-css p-rl-10 border-blue"}
            placeholder="Max 30 characters allowed"
            maxLength={30}
            type="text"
            value={rosterConfig.productionTrainingZoomPw}
            onChange={(e) =>
              dispatch(
                rosterConfigAction.productionTrainingZoomPw(e.target.value),
              )
            }
          />
        </Grid>
        <Grid item xs={1} className={"m-5-0px"}></Grid>
        <Grid className={"buttonContainer m-5-0px"} item xs={6}>
          {t("SRW")} :
        </Grid>
        <Grid item xs={4}>
          <TextField
            className={`info-section border-radius`}
            type="datetime-local"
            onChange={(e) => handleSrwDateChange(e)}
            inputFormat="YYYY/MM/DD"
            value={
              moment.utc(rosterConfig.srw.date).format("YYYY-MM-DD") +
              "T" +
              moment(
                rosterConfig.srw.time ? rosterConfig.srw.time : "00:00",
                "hh:mm A",
              ).format("HH:mm")
            }
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid className="text-center" item xs={1}>
          <CloseIcon
            onClick={(e) => {
              let obj = {
                date: null,
                time: null,
              };
              dispatch(rosterConfigAction.srw(obj));
            }}
          ></CloseIcon>
        </Grid>
        <Grid item xs={1} className={"m-5-0px"}></Grid>
        <Grid className={"buttonContainer m-5-0px"} item xs={6}>
          {t("clientTrainingLink")}
        </Grid>
        <Grid item xs={5}>
          <input
            name="wave"
            className={"dropdown-css p-rl-10"}
            placeholder="Max 300 characters allowed"
            maxLength="300"
            type="text"
            value={rosterConfig.clientSpecificLink}
            onChange={(e) =>
              dispatch(rosterConfigAction.clientSpecificLink(e.target.value))
            }
          />
        </Grid>
        <Grid item xs={1} className={"m-5-0px"}></Grid>
        <Grid className={"buttonContainer m-5-0px"} item xs={6}>
          {t("clientSpecificHostPw")}
        </Grid>
        <Grid item xs={5} className={"m-5-0px"}>
          <input
            name="wave"
            className={"dropdown-css p-rl-10"}
            placeholder="Max 30 characters allowed"
            maxLength="30"
            type="text"
            value={rosterConfig.clientSpecificPw}
            onChange={(e) =>
              dispatch(rosterConfigAction.clientSpecificPw(e.target.value))
            }
          />
        </Grid>
        <Grid item xs={1} className={"m-5-0px"}></Grid>
        <Grid className={"buttonContainer m-5-0px"} item xs={6}>
          {t("clientHostKey")}
        </Grid>
        <Grid item xs={5} className={"m-5-0px"}>
          <input
            name="wave"
            className={"dropdown-css p-rl-10"}
            placeholder="Max 30 characters allowed"
            maxLength="30"
            type="text"
            value={rosterConfig.clientSpecificZoomHostKey}
            onChange={(e) =>
              dispatch(
                rosterConfigAction.clientSpecificZoomHostKey(e.target.value),
              )
            }
          />
        </Grid>
        <Grid item xs={1} className={"m-5-0px"}></Grid>
        {props.type !== "clone" && (
          <>
            <Grid className={"buttonContainer m-5-0px"} item xs={3}>
              {t("idmTicketNo")} :
            </Grid>
            <Grid item xs={4} className={"m-5-0px border-purple"}>
              <div className={`${classes.IDM}`}>
                {idmTickets !== "" && <p>{idmTickets}</p>}
                {idmTickets === "" && (
                  <p className="colorgray">
                    Use BULK EDIT for Trainee-specific IDM Tickets
                  </p>
                )}
              </div>
            </Grid>
            <Grid item xs={2} className={"m-5-0px p-rl-10 "}>
              <AsttButtonDark onClick={() => setOpen(true)}>
                {t("view")}
              </AsttButtonDark>
            </Grid>
            <Grid item xs={2} className={"m-5-0px p-rl-10 "}>
              {idmTicketCreate ? (
                <AsttButtonDark onClick={handleClickOpen}>
                  {t("create")}
                </AsttButtonDark>
              ) : (
                <AsttButtonLight> Create </AsttButtonLight>
              )}
            </Grid>
          </>
        )}
        <Grid className={"buttonContainer m-5-0px"} item xs={12}>
          {!idmTicketCreate ? (
            <p className="italic-text">
              <span className={"font-style-italic redColor"}>
                {t("Warning")}
              </span>
            </p>
          ) : null}
        </Grid>

        <Grid className={"buttonContainer m-5-0px"} item xs={3}>
          {t("notes")}
        </Grid>

        <Grid item xs={9} className={"m-5-0px"}>
          <textarea
            name="Notes"
            className={`${classes.notes}`}
            type="text"
            value={rosterConfig.notes}
            onChange={(e) => dispatch(rosterConfigAction.notes(e.target.value))}
          />
        </Grid>
        <Grid className={"buttonContainer m-5-0px"} item xs={6}>
          <div>
            <p>
              {t("trainerName")} : {rosterConfig.traineeName}
            </p>
            <p>
              {t("trainerEmail")}: {rosterConfig.traineeEmail}
            </p>
          </div>
        </Grid>
        <Grid item xs={4} className={"m-5-0px"}>
          <div className="flex-display end-content">
            <button
              onClick={(e) => handleOpenSearchTrainer("trainer")}
              className={`${classes.button} border-blue`}
            >
              {" "}
              {t("searchTrainer")}
            </button>
            <SearchIcon className={classes.searchIcon}></SearchIcon>
          </div>
        </Grid>
        {rosterConfig.traineeName !== " " && (
          <Grid className="flex-display end-content align-center " item xs={1}>
            <CloseIcon
              onClick={(e) => {
                dispatch(rosterConfigAction.updateTrainerOracle(""));
                dispatch(rosterConfigAction.traineeName(" "));
                dispatch(rosterConfigAction.traineeEmail(" "));
              }}
            />
          </Grid>
        )}
        <Grid className={"buttonContainer m-5-0px"} item xs={6}>
          <div>
            <p>
              {t("ogName")}: {rosterConfig.ogName}
            </p>
            <p>
              {t("ogEmail")}: {rosterConfig.ogEmail}
            </p>
          </div>
        </Grid>
        <Grid item xs={4} className={"m-5-0px"}>
          <div className="flex-display end-content">
            <button
              onClick={(e) => handleOpenSearchTrainer("og")}
              className={`${classes.button} border-yellow`}
            >
              {" "}
              {t("searchOG")}
            </button>
            <SearchIcon className={classes.searchIcon}></SearchIcon>
          </div>
        </Grid>
        {rosterConfig.ogName !== " " && (
          <Grid className="flex-display end-content align-center " item xs={1}>
            <CloseIcon
              onClick={(e) => {
                dispatch(rosterConfigAction.updateOgOracle(""));
                dispatch(rosterConfigAction.ogName(" "));
                dispatch(rosterConfigAction.ogEmail(" "));
              }}
            />
          </Grid>
        )}
      </Grid>

      <IDMModal
        open={open}
        handleClose={handleClose}
        rosterID={props.rosterID}
      ></IDMModal>

      <IDMGenerateResponseModal
        {...idmResponseModalProps}
      ></IDMGenerateResponseModal>

      {props.type !== "clone" ? (
        <>
          {props.type === "edit" ? (
            <h2>
              {t("AssignedTrainee")}:{assignedTraineeData.length}
            </h2>
          ) : null}
          {assignedTraineeData.length ? (
            <div className="tableHolder">
              <table border="1" width="100%">
                <tr>
                  <th onClick={() => sortingRosterTrainee("candidateId")}>
                    <span>{t("Candidate Id")}</span>
                    <span>
                      <SouthIcon sx={headerStyle}></SouthIcon>
                      <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                    </span>
                  </th>
                  <th onClick={() => sortingRosterTrainee("oracleId")}>
                    <span>{t("Oracle Id")}</span>
                    <span>
                      <SouthIcon sx={headerStyle}></SouthIcon>
                      <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                    </span>
                  </th>
                  <th onClick={() => sortingRosterTrainee("requisitionId")}>
                    <span>{t("REQUISITION ID")}</span>
                    <span>
                      <SouthIcon sx={headerStyle}></SouthIcon>
                      <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                    </span>
                  </th>
                  <th
                    onClick={() => sortingRosterTrainee("preferredFirstName")}
                  >
                    <span>{t("First Name")}</span>
                    <span>
                      <SouthIcon sx={headerStyle}></SouthIcon>
                      <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                    </span>
                  </th>
                  <th onClick={() => sortingRosterTrainee("preferredLastName")}>
                    <span>{t("Last Name")}</span>
                    <span>
                      <SouthIcon sx={headerStyle}></SouthIcon>
                      <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                    </span>
                  </th>
                </tr>

                {assignedTraineeData.map((item, index) => {
                  const rowKey = `${item.candidateId}-${index}`;
                  return (
                    <tr key={rowKey}>
                      <td>{item.candidateId}</td>
                      <td>{item.oracleId}</td>
                      <td>{item.requisitionId}</td>
                      <td>{item.preferredFirstName}</td>
                      <td>{item.preferredLastName}</td>
                    </tr>
                  );
                })}
              </table>
            </div>
          ) : null}
        </>
      ) : null}
      <Drawer
        anchor={"right"}
        open={state["right"]}
        onClose={toggleDrawer("right", false)}
        PaperProps={{
          sx: { width: "55%", backgroundColor: "#f0f0f0" },
        }}
      >
        <div className={classes.container}>
          <Grid container sx={{ marginTop: 30 }}>
            <Grid item xs={11}>
              <Box
                component="span"
                sx={{
                  fontSize: "18px",
                  marginLeft: "30px",
                }}
              >
                {t("EnterRequisitionIDOracleID")} :
              </Box>
            </Grid>
            <Grid item xs={1}>
              <CloseIcon
                onClick={toggleDrawer("right", false, "add")}
              ></CloseIcon>
            </Grid>
            <Grid item xs={12}>
              <Typography
                id="roasterDate"
                sx={{
                  marginLeft: "30px",
                }}
              >
                Roster Lock Date :{" "}
                {moment(rosterConfig.rosterLockDate).format("YYYY-MM-DD")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h3"
                sx={{
                  marginLeft: "30px",
                  marginTop: "10px",
                }}
              >
                {t("REQUISITION ID")}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {requisitionValue === "" ? (
                <TextField
                  sx={{ marginLeft: 30, width: 300, paddingTop: 10 }}
                  size="small"
                  InputProps={{
                    sx: { backgroundColor: "#fff" },
                  }}
                  className="popup-text"
                  inputRef={requisitionRef}
                />
              ) : (
                <TextField
                  sx={{ marginLeft: 30, width: 300, paddingTop: 10 }}
                  size="small"
                  InputProps={{
                    sx: { backgroundColor: "#fff" },
                  }}
                  className="popup-text"
                  inputRef={requisitionRef}
                  value={requisitionValue}
                  onChange={($event) => requisitionValueChanged($event)}
                />
              )}
            </Grid>
            <Grid item xs={5}></Grid>
            <Grid item xs={2.5}>
              {traineeFilteredData.length ? (
                <AsttButtonLight onClick={onClear}>
                  {t("CLEAR")}
                </AsttButtonLight>
              ) : null}
            </Grid>
            <Grid item xs={0.25}></Grid>
            <Grid item xs={3.75}>
              <AsttButtonDark onClick={onSubmit}>
                {t("GetTrainees")}
              </AsttButtonDark>
            </Grid>
            <Grid item xs={0.5}></Grid>
            <Grid item xs={12}>
              <Typography
                variant="h3"
                sx={{
                  marginLeft: "30px",
                  marginTop: "10px",
                }}
              >
                {t("ORACLE ID")}
              </Typography>

              <Box
                component="i"
                className="italic-text"
                sx={{
                  marginLeft: "30px",
                }}
              >
                {t("Use commas to separate multiple IDs")}
              </Box>
            </Grid>
            <Grid item xs={12}>
              <TextField
                sx={{ marginLeft: 30, width: 300, paddingTop: 10 }}
                size="small"
                className="popup-text"
                inputRef={oracleRef}
                InputProps={{
                  sx: { backgroundColor: "#fff" },
                }}
              />
            </Grid>
          </Grid>

          {getSelectedTraineesText(selectedTrainerDropDownValue)}

          {traineeFilteredData.length ? (
            <Grid container>
              <Grid item xs={12} sx={{ marginTop: 10, padding: 20 }}>
                <TableContainer sx={{ height: 300 }} component={Paper}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          sx={{ backgroundColor: "#f0f0f0" }}
                        >
                          <input
                            type="checkbox"
                            onClick={(e) => {
                              setCheckAll(e.target.checked);
                              handleAllChecked(e);
                            }}
                            checked={checkAll}
                          />
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ padding: 0, backgroundColor: "#f0f0f0" }}
                          onClick={() => sortingTrainees("CandidateId")}
                        >
                          <span>{t("Candidate Id")}</span>
                          <Box sx={{ display: "inline-block" }}>
                            <SouthIcon sx={headerStyle}></SouthIcon>
                            <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                          </Box>
                        </TableCell>

                        <TableCell
                          align="center"
                          sx={{ padding: 0, backgroundColor: "#f0f0f0" }}
                          onClick={() => sortingTrainees("OracleId")}
                        >
                          <span>{t("Oracle Id")}</span>
                          <Box sx={{ display: "inline-block" }}>
                            <SouthIcon sx={headerStyle}></SouthIcon>
                            <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                          </Box>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ padding: 0, backgroundColor: "#f0f0f0" }}
                          onClick={() => sortingTrainees("FirstName")}
                        >
                          <span>{t("First Name")}</span>
                          <Box sx={{ display: "inline-block" }}>
                            <SouthIcon sx={headerStyle}></SouthIcon>
                            <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                          </Box>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ padding: 0, backgroundColor: "#f0f0f0" }}
                          onClick={() => sortingTrainees("LastName")}
                        >
                          <span>{t("Last Name")}</span>
                          <Box sx={{ display: "inline-block" }}>
                            <SouthIcon sx={headerStyle}></SouthIcon>
                            <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                          </Box>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ padding: 0, backgroundColor: "#f0f0f0" }}
                          onClick={() => sortingTrainees("EmployeeStatus")}
                        >
                          <span>{t("Oracle Status")}</span>
                          <Box sx={{ display: "inline-block" }}>
                            <SouthIcon sx={headerStyle}></SouthIcon>
                            <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                          </Box>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ padding: 0, backgroundColor: "#f0f0f0" }}
                          onClick={() => sortingTrainees("TraineeStatus")}
                        >
                          <span>{t("Current Status")}</span>
                          <Box sx={{ display: "inline-block" }}>
                            <SouthIcon sx={headerStyle}></SouthIcon>
                            <ArrowUpwardIcon sx={headerStyle}></ArrowUpwardIcon>
                          </Box>
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ padding: 0, backgroundColor: "#f0f0f0" }}
                        >
                          <select
                            id="oracleStatus"
                            name="oracleStatus"
                            value={selectedTrainerDropDownValue}
                            onChange={(e) => {
                              setSelectedTrainerDropDownValue(e.target.value);
                              setCheckAll(false);
                              clearCheck();
                              handleChange(e);
                            }}
                          >
                            {selectedTrainerDropDownValue !== "" &&
                              Object.entries(oracleStatus).map((t) => (
                                <option key={t[0]} value={t[0]}>
                                  {t[0]} ({t[1]})
                                </option>
                              ))}
                          </select>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {traineeFilteredData.map((row, i) => {
                        const rowkey = `${row.candidateId}-${i}`;
                        return (
                          <TableRow key={rowkey}>
                            <TableCell scope="row" align="center">
                              <input
                                type="checkbox"
                                name="candidateId"
                                sx={{ backgroundColor: "#fff" }}
                                value={
                                  row.CandidateId === "" ? i : row.CandidateId
                                }
                                onChange={($event) =>
                                  onChangeTraineeChecked(
                                    $event,
                                    row.OracleId,
                                    i,
                                  )
                                }
                                checked={row.isChecked}
                              />
                            </TableCell>
                            <TableCell align="center">
                              {row.CandidateId}
                            </TableCell>
                            <TableCell align="center">{row.OracleId}</TableCell>
                            <TableCell align="center">
                              {row.FirstName}
                            </TableCell>
                            <TableCell align="center">{row.LastName}</TableCell>
                            <TableCell align="center">
                              {row.EmployeeStatus}
                            </TableCell>
                            <TableCell align="center">
                              {row.TraineeStatus}
                            </TableCell>
                            <TableCell align="center">
                              {" "}
                              {row.Message_MultipleActiveRosters ? (
                                <Box
                                  component="span"
                                  title={row.Message_MultipleActiveRosters}
                                >
                                  <WarningAmberIcon
                                    sx={{
                                      fontSize: "14px",
                                      color: "error.main",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      multipleTraineeRedirection(row.OracleId)
                                    }
                                  />
                                </Box>
                              ) : null}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          ) : (
            <Typography
              variant="h3"
              sx={{
                marginLeft: "40px",
                marginTop: "10px",
              }}
            >
              <br />
              <br />
              {noRecords && "No Record found"}
            </Typography>
          )}
        </div>
        <div className={classes.buttonContainer}>
          <AsttButtonLight onClick={(e) => onTraineeSaveAndReq()}>
            {t("SAVE+REQ")}
          </AsttButtonLight>
          <AsttButton onClick={(e) => onTraineeSave()}>{t("SAVE")}</AsttButton>
          <AsttButtonLight onClick={() => onCancel()}>
            {t("CANCEL")}
          </AsttButtonLight>
        </div>
      </Drawer>
    </div>
  );
};

TraineeDetails.propTypes = {
  rosterID: PropTypes.string,
  type: PropTypes.string,
  classRequestId: PropTypes.string,
};

export default TraineeDetails;
